const FieldError = ({ message }) => {
  if (!message) return null;

  return <div className="field-error-text">{message}</div>;
};

export default FieldError;
